import { render, staticRenderFns } from "./ModalReferral.vue?vue&type=template&id=888118bc&scoped=true"
import script from "./ModalReferral.vue?vue&type=script&lang=js"
export * from "./ModalReferral.vue?vue&type=script&lang=js"
import style0 from "./ModalReferral.vue?vue&type=style&index=0&id=888118bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888118bc",
  null
  
)

export default component.exports